<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
        <md-card>
          <md-card-header data-background-color="red">
            <h4 class="title">Donor Search</h4>
            <p class="category">List of all the donors</p>
          </md-card-header>
          <md-card-content>
            <donor-search-table table-header-color="green"></donor-search-table>
          </md-card-content>
        </md-card>
      </div>

    </div>
  </div>
</template>

<script>
  import DonorSearchTable from '@/components/Tables/DonorSearchTable.vue'

  export default{
    components: {
      DonorSearchTable
    }
  }
</script>
